import { FC } from 'react';
import { ISpinner } from './spinner.props';
import { StyledLoader } from './spinner.styled';

export const Spinner: FC<ISpinner> = ({ className, variant, size }) => {
    return <StyledLoader className={className} variant={variant} size={size}></StyledLoader>;
};
